/**
 * Signup intent helpers for role-aware referral deep links.
 * Intent is navigation-only; referral attribution still uses ?ref=.
 */

export const SIGNUP_INTENTS = ['candidate', 'interviewer', 'recruiter'];

export const INTENT_REDIRECTS = {
  candidate: '/dashboard',
  interviewer: '/marketplace/apply',
  recruiter: '/hiring',
};

export const INTENT_LABELS = {
  candidate: 'Candidate',
  interviewer: 'Interviewer',
  recruiter: 'Recruiter',
};

export const INTENT_DESCRIPTIONS = {
  candidate: 'After signup they land on their dashboard to start interview practice.',
  interviewer: 'After signup they go straight to the interviewer application form.',
  recruiter: 'After signup they land on the hiring hub to post jobs and manage recruiting.',
};

const isValidIntent = (intent) => SIGNUP_INTENTS.includes(intent);

/**
 * Build a shareable signup URL for a referral code and role intent.
 */
export const buildSignupUrl = ({ code, intent, origin = typeof window !== 'undefined' ? window.location.origin : '' }) => {
  if (!code) return '';
  const params = new URLSearchParams({ ref: code });
  if (intent && isValidIntent(intent)) {
    params.set('intent', intent);
  }
  return `${origin}/signup?${params.toString()}`;
};

export const getIntentFromSearch = (search) => {
  const intent = new URLSearchParams(search).get('intent');
  return isValidIntent(intent) ? intent : null;
};

export const getRedirectForIntent = (intent) => {
  if (!isValidIntent(intent)) return null;
  return INTENT_REDIRECTS[intent];
};
